<template>
  <div>
    <ul class="f-list flex">
      <li v-for="item in list" class="center" :key="item">
        <div class="tx-center">
          <img src="../../assets/img/device/tr-transmission.gif" alt="" />
          <div class="mt10">防排烟风机</div>
          <div class="c-b blod ">{{ Number(item.value).toFixed(2) }}PPM</div>
          <div class="c999 f12">参考值：0～500PPM</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getWind } from "../../api/facility.js";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {},
  props: ["cpNum"],
  mounted() {
    if (this.cpNum) this.getList();
  },

  watch: {
    cpNum() {
      this.getList();
    },
  },
  methods: {
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "fe559562bb2b456b848a545bb5d2eb4a" : this.cpNum;

      getWind({ c_company_num: cNum }).then((res) => {
        // console.log(res)
        var arr = [];
        if (res.fengwar.length) {
          res.fengwar.map((item, index) => {
            arr.push({ value: item.value });
            this.list = arr;
          });
        } else {
          this.$message.warning("该业务尚未开通，请联系管理员");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
